'use strict';

angular.module('AcaApp').controller('SettingsController',
[
  '$scope',
  'SettingsService',
  '$mdDialog',
  'LayoutService',
  'SETTINGS',
  '$location',
  '$window',
  '$timeout',
  'PRINTNOTES',
  'ImportService',
  function($scope, SettingsService, $mdDialog, LayoutService, SETTINGS, $location, $window, $timeout, PRINTNOTES, ImportService){
    if($window.sessionStorage.profile !== 'CNV_ACAADMIN' && $window.sessionStorage.profile !== 'CNV_ACASOVOS') {
      $location.path('/');
    }
    var noteKey= '';
    $scope.inController = true;
    $scope.isEditNote = false;
    $scope.notes = [];
    LayoutService.setBody('left-column-gray');
    $scope.items = [
      'tin-masking',
      'data-reset',
      'print-notes',
      'map-library'
    ];
    $scope.buttonResetEnabled = true;
    $scope.buttonResetTextForm = SETTINGS.NOTAVAILABLE;
    $scope.buttonResetEnabledForm = true;
    $scope.buttonResetTextPart = SETTINGS.NOTAVAILABLE;
    $scope.buttonResetEnabledPart = true;
    $scope.buttonResetTextEmp = SETTINGS.NOTAVAILABLE;
    $scope.buttonResetEnabledEmp = true;
    $scope.enable = 'Enable';
    var setIsEditNote = function(value){
      $scope.isEditNote = value;
    };
    $scope.AddNote = function(){
      setIsEditNote(true);
      var note = {
        nkey: '',
        notetext1: '',
        notetext2: '',
        notetext3: '',
        notetext4: '',
        notetext5: '',
        btnAction: 'btnSave',
        errorMessage: '',
        action: 'save',
        disabled: false
      };
      $scope.notes.push(note);
    };
    $scope.aCustomMaps = [];
    $scope.selectedMap = '';
    $scope.selectedMapFullName = '';
    $scope.changedSection = function(){
      $scope.section = $scope.items[1];
      getDataReset();
      setIsEditNote(false);
      $mdDialog.hide();
    };
    $scope.showSection = function(section){
      switch(section){
        case 'print-notes':
          $scope.section = $scope.items[2];
          loadNoteList();
        break;
        case 'data-reset':
          $scope.inController = true;
          if($scope.isEditNote){
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/settings/modals/warning-edit-notes.html',
              parent: angular.element(document.body)
            });
          }
          else{
            $scope.changedSection();
          }
        break;
        case 'tin-masking':
          $scope.section = $scope.items[0];
          checkTinMask();
        break;
        case 'map-library':
          $scope.aCustomMaps = [];
          getStoredMapNames();
          $scope.section = $scope.items[3];
        break;
      }
    };
    $scope.getTaxYear = function(){
      return $window.sessionStorage.taxYear;
    };
    
    var getDataReset = function(){
      SettingsService.getCurrentData().then(function(data){
        if(data.result.COLUMN_VALUE === 'OK'){
          setButtonReset();
        }
      },
      function(error){
        console.log('Error: ', error);
      });
    };

    $scope.dataReset = function(entity){
      $mdDialog.show({
        scope: $scope,
        templateUrl: 'app/views/settings/modals/warning-reset.html',
        parent: angular.element(document.body),
        controller: 'ResetDataController',
        preserveScope: true,
        locals: {
          currentEntity: entity,
          taxYear: $scope.getTaxYear()
        }
      });
    };

    $scope.showModalWhy = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/settings/modals/why-reset.html',
        parent: angular.element(document.body)
      });
    };

    $scope.closeModal = function(){
      $mdDialog.hide();
    };

    var setButtonReset = function(){
      $scope.buttonResetEnabled = false;
      $scope.buttonResetTextForm = SETTINGS.RESET;
      $scope.buttonResetEnabledForm = false;
      $scope.buttonResetTextPart = SETTINGS.RESET;
      $scope.buttonResetEnabledPart = false;
      $scope.buttonResetTextEmp = SETTINGS.RESET;
      $scope.buttonResetEnabledEmp = false;
    };

    $scope.changeBtn = function(note){
      if(note.btnAction === 'btnSave'){
        note.btnAction = 'btnEdit';
      }
      else{
        setIsEditNote(true);
        note.btnAction = 'btnSave';
      }
    };

    $scope.save = function(note, form){
      if(form.$valid){
        note.errorMessage = '';
        if(note.action === 'save'){
          saveNote(note);
        }
        else{
          updateNote(note);
        }
      }
      else{
        note.errorMessage = PRINTNOTES.REQUIRED;
      }
    };
    /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
    var saveNote = function(note){
      SettingsService.saveNotes(prepareRpc(note)).then(function(){
        note.btnAction = 'btnEdit';
        note.action = 'edit';
        note.disabled = true;
        setIsEditNote(false);
      },
      function(error){
        note.errorMessage = error.data.error.frontend_message;
      });
    };

    var updateNote = function(note){
      SettingsService.updateNotes(prepareRpc(note)).then(function(){
        note.btnAction = 'btnEdit';
        setIsEditNote(false);
      },
      function(error){
        note.errorMessage = error.data.error.frontend_message;
      });
    };

    var prepareRpc = function(note){
      var rpc = {};
      note.nkey = note.nkey.trim();
      rpc.nkey = note.nkey;
      rpc.notetext1 = note.notetext1 === undefined || note.notetext1 === '' ? '_' : note.notetext1;
      rpc.notetext2 = note.notetext2 === undefined || note.notetext2 === '' ? '_' : note.notetext2;
      rpc.notetext3 = note.notetext3 === undefined || note.notetext3 === '' ? '_' : note.notetext3;
      rpc.notetext4 = note.notetext4 === undefined || note.notetext4 === '' ? '_' : note.notetext4;
      rpc.notetext5 = note.notetext5 === undefined || note.notetext5 === '' ? '_' : note.notetext5;
      return rpc;
    };

    $scope.deleteNotes = function(){
      SettingsService.deleteNotes(noteKey).then(function(data){
        if(data.result.value === true){
          loadNoteList();
          $mdDialog.hide();
        }
      });
    };

    $scope.showConfirmDeleteNote = function(event, note){
      noteKey = note.nkey;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/settings/modals/delete-note.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    var addAction = function(){
      _.each($scope.notes, function(element){
        element.notetext1 = element.notetext1 === '_' ? '' : element.notetext1;
        element.notetext2 = element.notetext2 === '_' ? '' : element.notetext2;
        element.notetext3 = element.notetext3 === '_' ? '' : element.notetext3;
        element.notetext4 = element.notetext4 === '_' ? '' : element.notetext4;
        element.notetext5 = element.notetext5 === '_' ? '' : element.notetext5;
        element.btnAction = 'btnEdit';
        element.action = 'edit';
        element.disabled = true;
      });
    };

    var setNotesData = function(data){
      $scope.notes = data.result.notes;
      if($scope.notes === undefined){
        $scope.notes = [];
      }
      addAction();
    };

    var loadNoteList = function(){
      SettingsService.getNotes().then(setNotesData);
    };

    $scope.cancel = function(){
      loadNoteList();
      setIsEditNote(false);
    };

    var checkTinMask = function(){
      SettingsService.getTinMaskSetting().then(function(data){
        $scope.tinMask = data.result.value;
        if($scope.tinMask === 'Y'){
          $scope.enabled = true;
        }
        else{
          $scope.enabled = false;
        }
        $scope.enable = $scope.enabled ? 'Enabled' : 'Enable';
      });
    };

    var getStoredMapNames = function(){
      ImportService.getStoredMapNames().then(function(data){
        data.result.forEach(function(map, index, mapList){
          if(mapList[index].FullName.substr(0, 16) !== SETTINGS.STANDARDMAPS){
            if(mapList[index].SettingName.substr(0,14) == SETTINGS.CORRECTIONMAPS){
              mapList[index].SettingNameUpd = mapList[index].SettingName.substr(14);
            }
            else{
              mapList[index].SettingNameUpd = mapList[index].SettingName;
            }
            $scope.aCustomMaps.push(map);
          }
        });
      });
    };

    var showMsgDeleteMap = function(msg){
      $scope.messageDelete = (msg === 'OK') ? SETTINGS.MESSAGEDELETEOK : SETTINGS.MESSAGEDELETEKO;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/settings/modals/delete-map-done.html',
        parent: angular.element(document.body)
      });
    };

    $scope.showConfirm = function(name, fullName, updName){
      $scope.selectedMap = name;
      $scope.selectedMapFullName = fullName;
      $scope.selectedMapUpdName = updName;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/settings/modals/delete-map.html',
        parent: angular.element(document.body)
      });
    };

    $scope.deleteMap = function(){
      $mdDialog.hide();
      SettingsService.deleteCustomMap($scope.selectedMap.toUpperCase()).then(function(data){
        showMsgDeleteMap(data.result.value);
      },
      function(error){
        console.log('Error: ', error);
      });
    };

    $scope.deleteMapDone = function(){
      $mdDialog.hide();
      $scope.aCustomMaps=[];
      getStoredMapNames();
    };

    $scope.updateTinMask = function(tinMask){
      SettingsService.updateTinMask(tinMask).then(function(){
        checkTinMask();
      });
    };
    $scope.showSection('tin-masking');
  }
]);
